// Recovered compiled webpack factory 64189. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Iy: () => c, MI: () => s, TC: () => u, kM: () => l });
  var n = r(30249),
    a = r(40364),
    o = r(17588),
    i = r(78714);
  let s = RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
  function l(e, t) {
    let r = (function (e) {
        let t;
        if (!e) return;
        let r = e.match(s);
        if (r)
          return (
            "1" === r[3] ? (t = !0) : "0" === r[3] && (t = !1),
            { traceId: r[1], parentSampled: t, parentSpanId: r[2] }
          );
      })(e),
      l = (0, n.yD)(t);
    if (!r?.traceId) return { traceId: (0, o.e)(), sampleRand: (0, i.hY)() };
    let u = (function (e, t) {
      let r = (0, a.i)(t?.sample_rand);
      if (void 0 !== r) return r;
      let n = (0, a.i)(t?.sample_rate);
      return n && e?.parentSampled !== void 0
        ? e.parentSampled
          ? (0, i.hY)() * n
          : n + (0, i.hY)() * (1 - n)
        : (0, i.hY)();
    })(r, l);
    l && (l.sample_rand = u.toString());
    let { traceId: c, parentSpanId: f, parentSampled: d } = r;
    return { traceId: c, parentSpanId: f, sampled: d, dsc: l || {}, sampleRand: u };
  }
  function u(e = (0, o.e)(), t = (0, o.Z)(), r) {
    let n = "";
    return (void 0 !== r && (n = r ? "-1" : "-0"), `${e}-${t}${n}`);
  }
  function c(e = (0, o.e)(), t = (0, o.Z)(), r) {
    return `00-${e}-${t}-${r ? "01" : "00"}`;
  }
}
